// easyui-togggle-button.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, AfterContentInit, Input, ViewChild, forwardRef, NgZone } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare let $: any;

@Component({
  selector: 'easyui-toggle-button',
  // template: `
  //   <div style="height: 100%">
  //     <div #host>
  //       <ng-content></ng-content>
  //     </div>
  //   </div>
  // `,
  template: '<div #host><ng-content></ng-content></div>',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EasyuiToggleButtonComponent),
      multi: true
    }
  ]
})
export class EasyuiToggleButtonComponent implements AfterContentInit, ControlValueAccessor {
  private host: any;
  private initialValue: boolean;
  private dataModel: boolean;
  private onControlChange: Function;
  private onControlTouched: Function;
  @Input('options') options: any = {};
  @ViewChild('host') hostElement: ElementRef;

  constructor(private zone: NgZone) {
  }

  ngAfterContentInit() {
    this.configura(this.options);
  }

  // la form notifica un cambiamento dal datamodel al controllo
  public writeValue(value: boolean) {
    if (this.host) {
      // registrare il valore in entrata - va bene anche null
      value ? this.select() : this.unselect();
      this.initialValue = value; // valore iniziale
      this.dataModel = value;
    }
  }

  public registerOnChange(fn: any) {
    this.onControlChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onControlTouched = fn;
  }

  public selected(): boolean {
    return this.host.linkbutton('options').selected;
  }

  public select() {
    this.host.linkbutton('select');
  }

  public unselect() {
    this.host.linkbutton('unselect');
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options: any) {
    const localoptions = {
      width: 35,
      height: 25,
      toggle: true,
      onClick: () => {
        const isSelected = this.selected();
        this.onControlChange(isSelected);
      }
    };
    Object.assign(localoptions, options);
    this.zone.runOutsideAngular(() => {
      this.host = $(this.hostElement.nativeElement);
      this.host.linkbutton(localoptions);
      this.host.css({'margin-right': '2px', 'margin-bottom': '2px'});
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-toggle-button.component.ts